var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Translate } from "../../../../I18N";
import { PreserveIcon } from "../../../../Layout/PreserveIcon";
import { useAtomValue } from 'jotai';
import { settingsAtom, userAtom } from "../../../atoms";
import { Button, Card, CopyValueInput } from "../../../Components/UI";
import { requestToken } from "../../../api/preserve";

const Preserve = () => {
  const settings = useAtomValue(settingsAtom);
  const user = useAtomValue(userAtom);
  const [token, setToken] = useState('');

  const handleRequest = async (e) => {
    e.preventDefault();
    const result = await requestToken();
    setToken(result);
  };

  useEffect(() => {var _preserve$config;
    const { preserve } = settings.features || {};
    const userConfigs = preserve === null || preserve === void 0 ? void 0 : (_preserve$config = preserve.config) === null || _preserve$config === void 0 ? void 0 : _preserve$config.find((conf) => {var _conf$user;return (conf === null || conf === void 0 ? void 0 : (_conf$user = conf.user) === null || _conf$user === void 0 ? void 0 : _conf$user._id) === (user === null || user === void 0 ? void 0 : user._id);});
    if (userConfigs) {
      const savedToken = userConfigs.token;
      setToken(savedToken);
    }
  }, [settings, user]);

  return (/*#__PURE__*/
    _jsx("div", { className: "w-full min-h-screen bg-gray-50 flex flex-col" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Preserve Extension" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Card, {
      title: /*#__PURE__*/
      _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Preserve Extension"), /*#__PURE__*/
      _jsx(PreserveIcon, { color: "#D20D6C" })
      ) }, void 0, /*#__PURE__*/


    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("span", {}, void 0, "1. "), /*#__PURE__*/
    _jsx("a", {
      href: "https://uwazi.io/page/9852italrtk/support",
      target: "_blank",
      rel: "noopener noreferrer",
      className: "text-primary-700 font-semibold hover:text-primary-800 mt-2 inline" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Install the browser extension.")
    )
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("span", {}, void 0, "2. "), /*#__PURE__*/
    _jsx(Translate, { translationKey: "Preserve Setup Description" }, void 0, "Request and copy the Extension Token bellow and paste it into the preserve extension settings."


    )
    )
    ), /*#__PURE__*/
    _jsx("hr", { className: "my-2 border-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "font-semibold text-gray-700 mb-2" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Configuration")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-1" }, void 0, /*#__PURE__*/
    _jsx(CopyValueInput, {
      value: token,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Extension Token"),
      id: "extension-token" }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex justify-end" }, void 0,
    !token && /*#__PURE__*/
    _jsx(Button, { onClick: handleRequest }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Request token")
    )

    )
    )
    )
    )
    )
    ));

};

export { Preserve };